// extracted by mini-css-extract-plugin
module.exports = {"error":"_3dWqOz","title":"_3ISAFp","subtitle":"_3dHsYX","button":"m7759j","surge-error-title":"fcnDKN","surge-image":"_2QpNmb"};